/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Nut(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M219.87207,66.73877l-84-47.478a16.08529,16.08529,0,0,0-15.74609,0l-84,47.478a16.0253,16.0253,0,0,0-8.127,13.92871v94.665a16.0253,16.0253,0,0,0,8.127,13.92871l84,47.478a16.08113,16.08113,0,0,0,15.74609,0l84-47.478a16.02529,16.02529,0,0,0,8.12695-13.92871v-94.665A16.02529,16.02529,0,0,0,219.87207,66.73877ZM127.999,164a36,36,0,1,1,36-36A36.04074,36.04074,0,0,1,127.999,164Z" />
    </Svg>
  );
}

export default Nut;
